import { SnackbarVariantsStyle } from "./snackbar.type";

export const variants: SnackbarVariantsStyle = {
  info: {
    borderColor: "primary-light-blue",
    backgroundColor: "snackbar-informative-color",
    progressBarColor: "primary-light-blue",
  },
  secondary: {
    borderColor: "primary-navy-blue",
    backgroundColor: "snackbar-secondary-color",
    progressBarColor: "primary-navy-blue",
  },
  warning: {
    borderColor: "secondary-orange",
    backgroundColor: "snackbar-warning-color",
    progressBarColor: "secondary-orange",
  },
  success: {
    borderColor: "secondary-green",
    backgroundColor: "snackbar-positive-color",
    progressBarColor: "secondary-green",
  },
  error: {
    borderColor: "primary-red",
    backgroundColor: "snackbar-negative-color",
    progressBarColor: "primary-red",
  },
};
